import { hmsAPI } from '@/api'

export const postFeedback = data => hmsAPI.put('/feedback', data)
export const deleteFeedback = imageId => hmsAPI.delete(`/feedback/${imageId}`)
